import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Avatar from '@material-ui/core/Avatar';

const styles = theme => ({
  candidatoChart: {
    display: 'flex',
    padding: '5px 16px 5px 16px',
    alignItems: 'center',
  },
  candidatoBar: {
    height: '20px',
    transition: 'width 0.5s',
    textAlign: 'right',
    lineHeight: '20px',
    fontWeight: 'bold',
    borderRadius: '0 5px 5px 0',
    border: '1px solid black',
  },
  candidatoBarRejeicao: {
    position: 'absolute',
    height: '20px',
    lineHeight: '20px',
    fontWeight: 'bold',
    transition: 'width 0.5s',
    right: '0',
    bottom: '0',
    border: 'solid 1px',
    borderRadius: '5px 0 0 5px',
    background:
      'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAKElEQVQYV2NkwA7+M2IR/8/AwMCILgEWBClGloALIkugCMIkMARBEgC7IAYGchlNYwAAAABJRU5ErkJggg==) repeat',
  },
});

class MajoritarioChart extends React.Component {
  render() {
    let { candidatos, classes } = this.props;
    let intencoes = [];
    if (candidatos && candidatos.length > 0) {
      let atual = null;
      candidatos.forEach(i => {
        if (
          atual === null ||
          atual.tipo !== i.tipo ||
          (atual.candidato ? atual.candidato.id : null) !==
            (i.candidato ? i.candidato.id : null)
        ) {
          atual = {
            tipo: i.tipo,
            candidato: i.candidato,
            partido: i.partido,
            total: 0.0,
            masculino: 0.0,
            feminino: 0.0,
          };
          intencoes.push(atual);
        }
        if (i.divisoes.length > 0) {
          atual[i.divisoes[0].nome.toLowerCase()] = i.media;
        } else {
          atual.total = i.media;
        }
      });
      intencoes.sort(
        (c1, c2) =>
          (!c2.candidato && !c2.partido ? -100.0 : c2.total) -
          (!c1.candidato && !c1.partido ? -100.0 : c1.total)
      );
      return (
        <div style={{ overflowX: 'auto', maxHeight: '450px' }}>
          {intencoes.map((c, i) => (
            <div key={i} className={classes.candidatoChart}>
              {c.candidato ? (
                c.candidato.avatar ? (
                  <Avatar src={c.candidato.avatar} />
                ) : (
                  <Avatar style={{ backgroundColor: c.candidato.partido.cor }}>
                    {c.candidato.nome.match(/[A-Z]/g)}
                  </Avatar>
                )
              ) : (
                <Avatar>{c.tipo[0]}</Avatar>
              )}

              <div style={{ width: '100%', position: 'relative' }}>
                {c.tipo === 'BRANCO' ? 'Brancos' : ''}
                {c.tipo === 'NULO' ? 'Nulos' : ''}
                {c.tipo === 'INDECISO' ? 'Indecisos' : ''}
                {c.tipo === 'NAO_VOTARA' ? 'Não Votará' : ''}
                {c.tipo === 'OUTRO' ? 'Outro' : ''}
                {c.tipo === 'CANDIDATO'
                  ? `${c.candidato.nome} (${c.candidato.numero})`
                  : ''}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div
                    className={classes.candidatoBar}
                    style={{
                      backgroundColor: c.candidato
                        ? c.candidato.partido.cor
                        : '#ccc',
                      width: `${c.total}%`,
                    }}
                    title={`Masculino: ${c.masculino.formatPercent()}, Feminino: ${c.feminino.formatPercent()}`}
                  />
                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>
                    {c.total.formatPercent()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return null;
  }
}

export default withStyles(styles)(MajoritarioChart);



// WEBPACK FOOTER //
// ./src/components/mapas/MajoritarioChart.js